import { render, staticRenderFns } from "./crossing-config.vue?vue&type=template&id=220a6110&scoped=true"
import script from "./crossing-config.vue?vue&type=script&lang=js"
export * from "./crossing-config.vue?vue&type=script&lang=js"
import style0 from "./crossing-config.vue?vue&type=style&index=0&id=220a6110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a6110",
  null
  
)

export default component.exports